import React, { useMemo, useState } from 'react';

const SUBSCRIPTION_ITEM = {
  itemId: 496,
  itemName: 'Store1688 Monthly Subscription',
  quantityAvailable: 100,
  isAvailable: true,
  description: 'Store1688 Monthly Subscription',
  type: 'SubscriptionPlan',
  categoryId: '205',
  price: 34.0,
  isColdStartRequest: false,
  image: '',
  items: null,
  isFeatured: false,
  minQtyRequired: 0,
  maxQtyRequired: 0,
  shippingRules: [],
  discountRules: [],
  barcode: null,
  taxProperties: {},
  subCategoryId: null,
  reviews: null,
  taxInclusive: false,
  specifications: null,
  questions: null,
  priceId: 'price_1To8cYLerkwRHOOg0H1zpx51',
  planId: 'prod_Unk6AWIZHM6v9A',
};

const SUBSCRIPTION_ENDPOINT = 'https://pne130ve2j.execute-api.us-east-1.amazonaws.com/dev/orders/subscriptions';
const ENTITY_ID = 'p_css2025';
const DEFAULT_MEMBER = {
  label: 'Po Zhang',
  value: '01',
  email: 'snr+testdev@trunksoft.in',
};

const modalOverlayStyle = {
  position: 'fixed',
  inset: 0,
  zIndex: 1000,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '16px',
  background: 'rgba(0, 0, 0, 0.55)',
};

const modalStyle = {
  width: 'min(92vw, 900px)',
  maxHeight: '92vh',
  overflowY: 'auto',
  borderRadius: '14px',
  background: '#ffffff',
  boxShadow: '0 18px 50px rgba(15, 23, 42, 0.35)',
  padding: '28px 32px',
  boxSizing: 'border-box',
};

const iconBoxStyle = {
  width: '72px',
  height: '72px',
  borderRadius: '14px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: '#eef6ff',
  border: '2px solid #cfe2ff',
  color: '#155eef',
  flex: '0 0 auto',
};


const inputStyle = {
  width: '100%',
  border: '1px solid #d8d8d8',
  borderRadius: '14px',
  padding: '14px 18px',
  fontSize: '20px',
  lineHeight: 1.2,
  color: '#252525',
  boxSizing: 'border-box',
  background: '#ffffff',
};

const resultPageStyle = {
  minHeight: '70vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '48px 16px',
  boxSizing: 'border-box',
};

const resultCardStyle = {
  width: 'min(94vw, 680px)',
  borderRadius: '18px',
  background: '#ffffff',
  boxShadow: '0 18px 50px rgba(15, 23, 42, 0.12)',
  border: '1px solid #e5e7eb',
  padding: '42px',
  textAlign: 'center',
  boxSizing: 'border-box',
};

const successIconStyle = {
  width: '78px',
  height: '78px',
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  margin: '0 auto 24px',
  background: '#ecfdf3',
  color: '#039855',
  fontSize: '46px',
  fontWeight: 700,
};

const cancelIconStyle = {
  width: '78px',
  height: '78px',
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  margin: '0 auto 24px',
  background: '#fff1f0',
  color: '#d92d20',
  fontSize: '46px',
  fontWeight: 700,
};

const resultButtonStyle = {
  display: 'inline-block',
  marginTop: '24px',
  padding: '14px 24px',
  borderRadius: '12px',
  border: '1px solid #2495f2',
  background: '#2495f2',
  color: '#ffffff',
  fontSize: '18px',
  fontWeight: 700,
  textDecoration: 'none',
};

export const SubscriptionSuccessPage = () => (
  <div style={resultPageStyle}>
    <div style={resultCardStyle}>
      <div style={successIconStyle}>✓</div>
      <h1 style={{ margin: 0, color: '#111827', fontSize: '34px' }}>Subscription setup successful</h1>
      <p style={{ margin: '16px 0 0', color: '#667085', fontSize: '19px', lineHeight: 1.5 }}>
        Your monthly TrackBiz subscription has been created successfully. You can now continue with your account setup.
      </p>
      <a href="/agreements" style={resultButtonStyle}>Back to Agreement</a>
    </div>
  </div>
);

export const SubscriptionCancelPage = () => (
  <div style={resultPageStyle}>
    <div style={resultCardStyle}>
      <div style={cancelIconStyle}>×</div>
      <h1 style={{ margin: 0, color: '#111827', fontSize: '34px' }}>Subscription setup canceled</h1>
      <p style={{ margin: '16px 0 0', color: '#667085', fontSize: '19px', lineHeight: 1.5 }}>
        The subscription payment was not completed. You can go back to the agreement and try setting up the monthly subscription again.
      </p>
      <a href="/agreements" style={resultButtonStyle}>Try Again</a>
    </div>
  </div>
);

const PaymentStep = ({ checkoutUrl }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [trialPeriodDays, setTrialPeriodDays] = useState('1');
  const [selectedMemberId, setSelectedMemberId] = useState(DEFAULT_MEMBER.value);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const selectedMember = useMemo(() => DEFAULT_MEMBER, []);

  const openSubscriptionModal = () => {
    setErrorMessage('');
    setIsModalOpen(true);
  };

  const closeSubscriptionModal = () => {
    if (isSubmitting) return;
    setIsModalOpen(false);
    setErrorMessage('');
  };

  const handleContinueToPayment = async () => {
    const numericTrialDays = Number(trialPeriodDays || 0);

    if (!Number.isFinite(numericTrialDays) || numericTrialDays < 0) {
      setErrorMessage('Please enter a valid free trial length.');
      return;
    }

    const payload = {
      email: selectedMember.email,
      memberId: selectedMemberId,
      planId: SUBSCRIPTION_ITEM.planId,
      priceId: SUBSCRIPTION_ITEM.priceId,
      trialPeriodDays: numericTrialDays,
    };

    try {
      setIsSubmitting(true);
      setErrorMessage('');

      const response = await fetch(SUBSCRIPTION_ENDPOINT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          entityid: ENTITY_ID,
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json().catch(() => ({}));

      if (!response.ok) {
        throw new Error(data?.message || data?.error || 'Unable to create Stripe checkout session.');
      }

      const stripeCheckoutUrl = data?.checkoutUrl || data?.url || checkoutUrl;
      if (!stripeCheckoutUrl) {
        throw new Error('Stripe checkout URL was not returned.');
      }

      window.location.href = stripeCheckoutUrl;
    } catch (error) {
      setErrorMessage(error?.message || 'Unable to continue to payment.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="agreements-step-content">
      <h2>Payment Details</h2>

      <p>
        Customer will enter monthly subscription payment details securely through Stripe. Card details
        will be collected by Stripe and will not be stored directly by TrackBiz.
      </p>

      <div className="agreements-review-box">
        <h3>Payment Summary</h3>
        <p>TrackBiz Monthly Subscription: $34.00/month</p>
      </div>

      <p>
        The Stripe card reader hardware charge will be handled separately and is not included in this
        monthly subscription setup.
      </p>

      <div style={{ marginTop: '24px' }}>
        <button
          type="button"
          onClick={openSubscriptionModal}
        >
          Setup Monthly Subscription
        </button>
      </div>

      {isModalOpen && (
        <div style={modalOverlayStyle} role="dialog" aria-modal="true" aria-labelledby="subscription-modal-title">
          <div style={modalStyle}>
            <div style={{ display: 'flex', justifyContent: 'space-between', gap: '24px', marginBottom: '28px' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                <div style={iconBoxStyle} aria-hidden="true">
                  <svg width="42" height="42" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="2.75" y="5" width="18.5" height="14" rx="1" />
                    <path d="M2.75 9h18.5" />
                    <path d="M16 15.5h2.75" />
                  </svg>
                </div>
                <div>
                  <h2 id="subscription-modal-title" style={{ margin: 0, fontSize: '28px', lineHeight: 1.1, color: '#111827' }}>
                    Purchase subscription
                  </h2>
                  <p style={{ margin: '14px 0 0', fontSize: '18px', lineHeight: 1.25, color: '#697386' }}>
                    Confirm the plan, member, and trial settings before continuing to payment.
                  </p>
                </div>
              </div>
              <button
                type="button"
                onClick={closeSubscriptionModal}
                disabled={isSubmitting}
                aria-label="Close subscription modal"
                style={{
                  border: 0,
                  background: 'transparent',
                  color: '#7c7c7c',
                  fontSize: '54px',
                  lineHeight: 1,
                  cursor: isSubmitting ? 'not-allowed' : 'pointer',
                }}
              >
                ×
              </button>
            </div>

            <div style={{ border: '1px solid #e0e3e8', borderRadius: '14px', padding: '22px', marginBottom: '36px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', gap: '24px', alignItems: 'center' }}>
                <span style={{ textTransform: 'uppercase', fontSize: '18px', fontWeight: 700, color: '#697386', letterSpacing: '0.04em' }}>Plan</span>
                <strong style={{ fontSize: '24px', color: '#111827', textAlign: 'right' }}>{SUBSCRIPTION_ITEM.itemName}</strong>
              </div>
              <div style={{ height: '1px', background: '#e9edf3', margin: '28px 0' }} />
              <div style={{ display: 'flex', justifyContent: 'space-between', gap: '24px', alignItems: 'center' }}>
                <div>
                  <span style={{ display: 'block', textTransform: 'uppercase', fontSize: '18px', fontWeight: 700, color: '#697386', letterSpacing: '0.04em' }}>Amount</span>
                  <strong style={{ display: 'block', marginTop: '10px', fontSize: '26px', color: '#111827' }}>$ {SUBSCRIPTION_ITEM.price.toFixed(2)}/month</strong>
                </div>
                <span style={{ borderRadius: '10px', background: '#e6f4ff', color: '#155eef', padding: '10px 14px', fontSize: '16px', fontWeight: 700, letterSpacing: '0.04em' }}>
                  {SUBSCRIPTION_ITEM.planId.toUpperCase()}
                </span>
              </div>
            </div>

            <div style={{ marginBottom: '34px' }}>
              <label htmlFor="subscription-member" style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '18px', fontSize: '18px', fontWeight: 700, color: '#374151' }}>
                <span aria-hidden="true">♙</span> Subscribe for
              </label>
              <select
                id="subscription-member"
                value={selectedMemberId}
                onChange={(event) => setSelectedMemberId(event.target.value)}
                disabled={isSubmitting}
                style={{ ...inputStyle, appearance: 'auto' }}
              >
                <option value={DEFAULT_MEMBER.value}>{DEFAULT_MEMBER.label}</option>
              </select>
            </div>

            <div style={{ marginBottom: '36px' }}>
              <label htmlFor="subscription-trial-days" style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '18px', fontSize: '18px', fontWeight: 700, color: '#374151' }}>
                <span aria-hidden="true">▣</span> Free trial length
              </label>
              <div style={{ position: 'relative' }}>
                <input
                  id="subscription-trial-days"
                  value={trialPeriodDays}
                  onChange={(event) => setTrialPeriodDays(event.target.value.replace(/\D/g, ''))}
                  disabled={isSubmitting}
                  inputMode="numeric"
                  style={{ ...inputStyle, paddingRight: '112px' }}
                />
                <span style={{ position: 'absolute', right: '24px', top: '50%', transform: 'translateY(-50%)', fontSize: '18px', color: '#252525' }}>
                  days
                </span>
              </div>
            </div>

            {errorMessage && (
              <div style={{ marginBottom: '24px', padding: '14px 18px', borderRadius: '10px', background: '#fff1f0', color: '#a8071a', fontSize: '18px' }}>
                {errorMessage}
              </div>
            )}

            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '14px' }}>
              <button
                type="button"
                onClick={closeSubscriptionModal}
                disabled={isSubmitting}
                style={{
                  padding: '14px 24px',
                  borderRadius: '14px',
                  border: '1px solid #d8d8d8',
                  background: '#ffffff',
                  color: '#252525',
                  fontSize: '18px',
                  cursor: isSubmitting ? 'not-allowed' : 'pointer',
                }}
              >
                Back
              </button>
              <button
                type="button"
                onClick={handleContinueToPayment}
                disabled={isSubmitting}
                style={{
                  padding: '14px 24px',
                  borderRadius: '14px',
                  border: '1px solid #2495f2',
                  background: '#2495f2',
                  color: '#ffffff',
                  fontSize: '18px',
                  fontWeight: 700,
                  cursor: isSubmitting ? 'not-allowed' : 'pointer',
                }}
              >
                {isSubmitting ? 'Starting Payment...' : 'Continue to Payment'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PaymentStep;